"use strict";
var ApiQuoteFlight = (function () {
    function ApiQuoteFlight() {
    }
    return ApiQuoteFlight;
}());
exports.ApiQuoteFlight = ApiQuoteFlight;
//# sourceMappingURL=D:/a/1/s/purchase/src/models/api-quote-flight.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/purchase/src/models/api-quote-flight.model.js